<template>
  <div class="-trend">
    <div class="c_main -pad-btm">
      <div class="inner">
        <nav class="c_pnkz">
          <ul class="c_pnkz_list">
            <li>
              <a class="c_pointer" @click="$router.push({ name: 'Home' })">
                ホーム
              </a>
            </li>
            <li>
              <a>
                {{ category }}
              </a>
            </li>
          </ul>
        </nav>
        <p class="c_main_ttl">{{ category }}</p>

        <privacy-policy></privacy-policy>
        <survey-single></survey-single>
        <div class="c_pageback">
          <a class="c_txtlink" @click="$router.push({ name: 'Home' })">
            トップに戻る
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SurveySingle from "@/components/SurveySingle";
import PrivacyPolicy from "@/components/PrivacyPolicy";

export default {
  components: {
    SurveySingle,
    PrivacyPolicy
  },
  props: {
    id: {
      type: String
    },
    category: {
      type: String
    },
    routerName: {
      type: String
    }
  },
  methods: {
    pushHistory() {
      this.$authAxios.post("/api/history", { id: this.id });
    }
  }
};
</script>
